import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import React, { useEffect, useState } from 'react';

function TimedProgressBar({ seconds }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        const diff = 100 / (seconds * 10);
        return Math.min(oldProgress + diff, 100);
      });
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress variant='determinate' value={progress} />
    </Box>
  );
}

export default TimedProgressBar;
